import React from "react";
import IMAGES from "../../constant/IMAGES";

const Notify = ({
  title = "Gửi yêu cầu thành công",
  decs = "Yêu cầu của bạn đã được gửi thành công. Bộ phận CSKH sẽ liên hệ bạn thời gian sớm nhất",
  err = false,
}: {
  title?: string;
  decs?: string;
  notify?: any;
  err?: boolean;
}) => {
  return (
    <div className="flex flex-col relative overflow-hidden">
      <div className="flex gap-3 md:gap-6 items-center">
        {/* {err ? (
          <img
            src={IMAGES.bgNoti}
            alt="icon-err"
            className="absolute inset-0"
          />
        ) : (
          <img
            src={IMAGES.bgErr}
            alt="icon-success"
            className="absolute inset-0"
          />
        )} */}
        {err ? (
          <img src={IMAGES.iconErr} alt="icon-err" />
        ) : (
          <img src={IMAGES.iconSuss} alt="icon-success" />
        )}
        <div className="flex flex-col gap-3">
          <h1
            className={`text-base md:text-lg font-semibold ${
              err ? "text-[#FF453A]" : "text-[#13B601]"
            }`}
          >
            {title}
          </h1>
          <p
            className={`text-xs md:text-sm ${
              err ? "text-[#ECC1BD]" : "text-[#BDECCB]"
            }`}
          >
            {decs}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Notify;
